import { Paper } from "@mui/material"
import hljs from "highlight.js/lib/core"
import lua from "highlight.js/lib/languages/lua"
import "highlight.js/styles/dark.min.css"

import React, { useEffect } from "react"

import { AGENT_SOURCE } from "./agent-source"

hljs.registerLanguage("lua", lua)

export function BlueprintSourceCode() {
  useEffect(() => {
    hljs.highlightAll()
  }, [])

  return (
    <Paper sx={{ margin: 0, maxHeight: "calc(100vh - 400px)", overflow: "auto" }} component="pre">
      <code className="language-lua">{AGENT_SOURCE}</code>
    </Paper>
  )
}
